import {createMultiPathSVG} from './TEMPLATE'

// phosphor: download-simple
export const Download_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z',
  ],
  viewBox: '0 0 256 256',
})
